export default {
    add_stage: "Add stage",
    additional: "Additional",
    alternative: "Alternative",
    amount_completed: "Amount completed",
    apply_plan_treatment: "Apply treatment plan",
    apply_to_which_teeth: "Which teeth to apply to",
    apply_treatment_stage_template: "Apply treatment step template",
    are_you_sure_you_want_to_cancel_plan: "Are you sure you want to cancel the plan?",
    by_stages: "By stages",
    calls_planning: "Calls planning",
    cancel_plan_treatment: "Cancel treatment plan",
    changes_in_current_stage_were_not_saved: "Changes in the current step are not saved",
    choose_criterias_for_fill: "Select the required criteria to fill out",
    collapse: "Collapse",
    comments: "Comments",
    completed_sum: "Completed sum",
    complex_doctor: "Complex doctor",
    'DD.MM.YYYY': "DD.MM.YYYY",
    deadline2: "Deadline",
    delete_stage: "Delete stage",
    document_header: "Treatment plan header",
    editing_is_blocked_now_user_is_working: "Editing is temporarily unavailable: {user} is currently working",
    expand: "Expand",
    grouped: "Grouped",
    grouped_by_services: "Grouped by services",
    grouped_by_teeth: "Grouped by teeth",
    hide_tooth_formula: "Hide dental formula",
    kits_and_materials: "Kits and materials",
    last_update: "Last update",
    left: "Left",
    level_description: "Level description",
    main_complaints: "Main complaints",
    not_signed: "Not signed",
    notification_date: "Notification date",
    plan: "Plan",
    plan_status: "Plan Status",
    plan_treatment_application: "Applying the treatment plan",
    plan_treatment_status: "Treatment plan status",
    plan_type: "Plan type",
    planned_sum: "Planned sum",
    previous_visits: "Past visits",
    quantity: "Quantity",
    recommended: "Recommended",
    reset_all: "Reset all",
    route_list: "Route list",
    save_as_plan_stage_template: "Save as treatment step template",
    select_a_doctor_2: "Choose a doctor",
    select_all: "Select all",
    select_field: "Choose a direction",
    select_number: "Select number",
    select_plan: "Choose a plan",
    select_type: "Select type",
    services_selected: "Services selected",
    show_tooth_formula: "Show dental formula",
    sign_without_upload: "Sign without upload",
    signed_at: "Signed",
    stage_deletion_confirm_text: "The stage will be deleted without the possibility of recovery.",
    stage_doctor: "Stage doctor",
    stage_title: "Stage name",
    stages_discount: "Discount in stages",
    total_sum: "Total sum",
    treatment_plan_amount: "Treatment plan amount",
    treatment_plan_doctor: "Treatment plan doctor",
    treatment_template_application: "Applying a treatment template",
    which_fields_to_fill: "What fields to fill out",
    write_patient_complaints: "Write down the patient's complaints",
    write_stage_description: "Write a description of the stage"
}
